import { Component, OnInit, Input } from '@angular/core';
import { NxiMobileService } from '../services/nxi-mobile.service';
import { INavigationService, PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation } from '@pershing/nxi-common';
import { Router } from '@angular/router';

@Component({
    selector: 'nxi-mobile',
    templateUrl: 'nxi-mobile.component.html'
})
export class NxiMobileComponent implements OnInit {
    @Input() isMobileTheme: boolean;
    @Input() isTabletTheme: boolean;
    hideMenu: boolean;
    child: any;
    currentUrl: any;
    grandChild: any;
    parent: any;
    fourthChild: any;
    parentHasChild: boolean = false;
    constructor(
        private mobileService: NxiMobileService, private navigationService: INavigationService,
        private translationService: PershingTranslationService, private router: Router) {
        this.translationService.addTranslationFolder('@pershing/nxi-navigation', 'node_modules/@pershing/nxi-navigation/lib');
    }

    ngOnInit() {
        this.router.events.subscribe((url: any) => {
            if (url.url) {
                this.currentUrl = url.url;
            }
            if (this.currentUrl.includes('edelivery-pending-enroll') || this.currentUrl.includes('edelivery-promotion')) {
                this.hideMenu = true;
            } else {
                this.hideMenu = false;
            }
        });
        this.navigationService.getParentPage().subscribe(
            (data: any) => {
                this.parent = data;
                this.parentHasChild = (this.parent && this.parent.children && this.parent.children.length > 0);
            }
        );
        this.navigationService.getChildPage().subscribe(
            (data: any) => this.child = data
        );
        this.navigationService.getGrandChildPage().subscribe(
            (data: any) => {
                this.grandChild = data;
                this.fourthChild = null;
            }
        );
        this.navigationService.getFourthChildPage().subscribe(
            (data: any) => this.fourthChild = data
        );
    }

    handleNavigation() {
        let nav = new NxiNavigation();
        nav.parentPage = this.parent;
        if (this.parentHasChild) {
            nav.childPage = this.child;
            if (this.grandChild && this.grandChild.hideFromNavigation) {
                nav.parentPage = this.grandChild;
            } else {
                nav.grandchildPage = this.grandChild;
            }
        }
        this.navigationService.handleNavigation(nav);
    }

    toggleSideNavDisplay() {
        // Open or Close side nav by trigger the toggle which would set isOpen value true/false.
        // The side nav component (mobile-nav.component.ts) subscribes to this event and based on the isOpen value
        // it would do the actual of open/close the side nav accordingly.
        this.mobileService.toggle();
        // This is to further help HostListener in mobile-nav to discern that click is from menu.
        this.mobileService.mobileMenuTabClickEvent(true);
    }
}
